import { Eye, X } from 'lucide-react';
import { sairDoEspelho } from './api';

// A faixa que fica na tela o tempo todo enquanto o espelho esta aberto ([DA-634]).
//
// ⚠️ **Ela e' obrigatoria, e o motivo nao e' enfeite**: o espelho e' pixel por pixel
// o app do cliente — nao ha nada na tela que diga de quem e' aquela conta. Sem a
// faixa, sair da tela e voltar dez minutos depois (ou pegar o celular de novo
// amanha, porque a credencial dura 2h e o `/me` a renova) e' confundir a visao de
// outra pessoa com a propria. Ela e' o unico caminho de volta, e por isso o botao
// de sair mora nela.
//
// ⚠️ **`position: fixed`, e o recuo vem por CSS** (`body:has(.faixa-espelho)` no
// `styles.css`). Somar altura no fluxo quebraria o chat: ele e' `height: 100dvh`
// cravado, e uma tarja acima empurraria a barra de digitar pra fora da tela — o
// defeito que a [DA-525] ja cobrou uma vez.

const ALTURA = 34;

export function FaixaEspelho({ nome }: { nome: string }): React.ReactElement {
  function sair(): void {
    // Sem credencial guardada nao ha pra onde voltar: o `sairDoEspelho` ja
    // encerrou a sessao, e a recarga cai na tela de entrada — desfecho honesto,
    // em vez de uma tela que finge estar logada.
    sairDoEspelho();
    window.location.reload();
  }

  return (
    <div
      className="faixa-espelho"
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, height: ALTURA, zIndex: 90,
        // Roxo: nao e' erro (vermelho), nao e' pendencia (laranja) e nao e' a marca
        // (cobre) — precisa ser uma cor que NAO significa nada nas telas do app,
        // pra nao ser lida como estado do cliente (`sistema/CLAUDE.md`, principio 3).
        // Fundo solido + letra preta, nunca tint lavado, e cor nenhuma carrega o
        // significado sozinha: quem diz o que e' isto e' o texto.
        backgroundColor: '#c4b5fd', color: '#000',
        display: 'flex', alignItems: 'center', gap: 8, padding: '0 6px 0 12px',
        fontSize: 12.5, fontWeight: 700,
      }}
    >
      <Eye size={15} style={{ flexShrink: 0 }} />
      {/* ⚠️ **Quem trunca e' o NOME, nunca o "só leitura"** — medido a 390px na
          release publicada: com o texto todo num span so, `JOAO PEDRO FIODECOBRE`
          comia a linha e a faixa terminava em *"· s..."*, cortando exatamente a
          metade que impede de confundir o espelho com o app de verdade. O nome
          encolhe porque ele e' o que varia; a garantia e' fixa. */}
      <span style={{ flex: '0 1 auto', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        Vendo como <b>{nome}</b>
      </span>
      <span style={{ flex: '0 0 auto', marginRight: 'auto', whiteSpace: 'nowrap' }}>&nbsp;· só leitura</span>
      <button
        type="button"
        onClick={sair}
        style={{
          flexShrink: 0, height: 26, display: 'flex', alignItems: 'center', gap: 4,
          padding: '0 10px', borderRadius: 999, backgroundColor: 'rgba(0,0,0,.14)',
          color: '#000', fontSize: 12.5, fontWeight: 700,
        }}
      >
        <X size={13} /> Sair
      </button>
    </div>
  );
}
